import { defineStore } from 'pinia';
import axios from 'axios';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';

// eslint-disable-next-line import/prefer-default-export
export const useAttachmentsStore = defineStore('attachmentsStore', {
  state: () => {
    const {
      handleError
    } = useSnackbarHandler();
    return {
      handleError
    };
  },
  actions: {
    async uploadAttachment(filesToUpload, id) {
      const attachments = new FormData();
      filesToUpload.forEach(file => {
        attachments.append('attachments', file, file.fileName);
      });
      try {
        await axios({
          url: `/expenses/${id}/attachments`,
          method: 'PUT',
          data: attachments,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      } catch (error) {
        this.handleError('Unable to save attachment');
      }
    },
    async deleteExistingAttachment(fileToRemove) {
      axios({
        url: `/expenses/attachment?expenseAttachmentId=${fileToRemove.expenseAttachmentId}`,
        method: 'DELETE'
      });
    },
    async downloadAttachmentBlob(expenseAttachmentId) {
      const {
        data
      } = await axios({
        url: `/expenseattachments/${expenseAttachmentId}/download`,
        method: 'GET',
        responseType: 'blob'
      });
      return data;
    }
  }
});